import React from 'react';

export const SinglePleatType = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M-6.7 20.5h97.3v76.1H-6.7z"
        />
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M31.7 96.6C31.2 67.1 34 49.4 35.2 45c1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M37.4 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.4-3.3 4.4 0z"
            fill="#96b0bb"
          />
        </g>
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M45.1 96.6c-.5-29.5 2.3-47.2 3.5-51.6 1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M50.8 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.4-3.3 4.4 0z"
            fill="#96b0bb"
          />
        </g>
        <path
          d="M-2.9 20.8c.1 3-.7 21.2-.7 21.2C-.2 48.4.5 78.2.4 96.6H-3c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.3-3.3 4.3 0z"
          fill="#96b0bb"
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M58.5 96.6C58 67.1 60.8 49.4 62 45c1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M64.2 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6H64c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.4-3.3 4.4 0z"
            fill="#96b0bb"
          />
        </g>
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M4.9 96.6C4.4 67.1 7.2 49.4 8.4 45c1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M10.5 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6H3c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.2-2.4 4.2-3.3 4.2 0z"
            fill="#96b0bb"
          />
        </g>
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M18.3 96.6c-.5-29.5 2.3-47.2 3.5-51.6 1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M24 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.4-3.3 4.4 0z"
            fill="#96b0bb"
          />
        </g>
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M71.9 96.6c-.5-29.5 2.3-47.2 3.5-51.6 1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M77.6 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6H70c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.2-2.4 4.3-3.3 4.3 0z"
            fill="#96b0bb"
          />
        </g>
        <g
          stroke="#233762"
          strokeWidth={0.721}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        >
          <path
            d="M85.3 96.6c-.5-29.5 2.3-47.2 3.5-51.6 1.2 4.4 4 22 3.5 51.6h-7z"
            fill="#233762"
          />
          <path
            d="M91 20.8c.1 3-.7 21.2-.7 21.2 3.4 6.4 4.1 36.2 4 54.6h-3.5c.5-29.5-.8-47.2-2-51.6-1.2 4.4-2.5 22-2 51.6h-3.5c-.1-18.3.6-48.1 4-54.6 0 0-.8-19.9-.7-21.2-.1-2.4 4.4-3.3 4.4 0z"
            fill="#96b0bb"
          />
        </g>
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
